export function downloadFileLink(file: Blob, title: string) {
  const objectUrl = window.URL.createObjectURL(file)
  const a = document.createElement('a')
  a.href = objectUrl
  a.setAttribute('download', title)
  document.body.appendChild(a)
  a.click()
}
